export default class Alerts {
  constructor() {
    this.initListeners();
    this.showAlert();
  }

  showAlert() {
    const $id = $('.js-alert-bar').attr('id');

    if (sessionStorage.getItem('alert') != $id) {
      $('.js-alert-bar').addClass('active');
    }
  }

  initListeners() {
    $('.js-dismiss-alert').on('click', (e) => {
      const $id = $(e.currentTarget).data('id');

      $('.js-alert-bar').removeClass('active');
      sessionStorage.setItem('alert', $id);
    });
  }
}
